const FIRSTAM_REPORT_CONTEXT_KEY = "firstam_report_ctx";

export function clearFirstamReportContext(storage) {
  storage.removeItem(FIRSTAM_REPORT_CONTEXT_KEY);
}

export { FIRSTAM_REPORT_CONTEXT_KEY };
